import script from "./CatalogPublicationSaveSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogPublicationSaveSettings.vue?vue&type=script&setup=true&lang=js"

import "./CatalogPublicationSaveSettings.vue?vue&type=style&index=0&id=5da813ff&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5da813ff"]])

export default __exports__